/**
 * Chrome for the panels that dock on top of the composer: pending approvals,
 * elicitation questions and the plan follow-up banner.
 *
 * They share a height ceiling because they share a failure mode. The composer
 * is an auto-height sibling of the transcript inside a flex column, so anything
 * these panels render pushes the transcript down; the transcript carries
 * `min-h-0`, so it obediently shrinks to nothing. On a desktop window that goes
 * unnoticed, but on a phone a four-option question is taller than the viewport
 * and the conversation is squeezed out of existence — the user answers blind,
 * unable to scroll back to the message that prompted the question.
 *
 * `svh` rather than `dvh`: the ceiling is measured against the *small* viewport,
 * the one with the browser toolbars showing, so the panel does not resize (and
 * reflow the transcript underneath it) every time mobile Safari retracts its
 * chrome mid-scroll.
 */
export const COMPOSER_TOP_PANEL_CLASSNAME =
  "max-h-[45svh] overflow-y-auto overscroll-contain rounded-t-[23px] border-b border-border/65 bg-muted/20 sm:max-h-[60svh]";
